import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import { softwareProjectLayoutNoOnboarding } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { cmpVelocityRoute } from '@atlassian/jira-router-routes-classic-projects-routes/src/cmpVelocityRoute.tsx';
import VelocityPage, {
	LazyNextGenVelocityReport,
} from '@atlassian/jira-router-routes-next-gen-entries/src/ui/software/reports/velocity/index-old.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { velocityReportPageEntrypoint } from '@atlassian/jira-router-routes-next-gen-entries/src/ui/software/reports/velocity/index.tsx';
import { getTMPReportsCommonResource } from './common/ui/resources/reports/index.tsx';

/**
 * @deprecated delete when cleaning up jira_reports_route_migration_to_entry_points
 */
const getHorizontalNavResources = () =>
	fg('jira_reports_route_migration_to_entry_points') ? [] : [horizontalNavJiraResource];

export const cmpVelocityRouteEntry = createEntry(cmpVelocityRoute, () => ({
	group: 'software',
	ufoName: 'software-reports.velocity-report-cmp',
	component: fg('jira_reports_route_migration_to_entry_points') ? undefined : VelocityPage,
	layout: softwareProjectLayoutNoOnboarding,
	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarSoftwareClassic,
	},
	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
		incidentExperimentTraitResource,
		projectContextResource,
		forgeProjectModuleResource,
		staticSidebarShortcutsResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		...getHorizontalNavResources(),
		// end of resources expanded from getNavigationSidebarProjectResource
		...getTMPReportsCommonResource(),
	],
	forPaint: fg('jira_reports_route_migration_to_entry_points')
		? undefined
		: [LazyAtlassianNavigation, LazyNextGenVelocityReport],
	entryPoint: () =>
		fg('jira_reports_route_migration_to_entry_points') ? velocityReportPageEntrypoint : undefined,
}));
